import * as THREE from 'three';

const VERT = `
uniform float uTime;
varying vec3 vPos;
varying vec3 vN;
void main(){
  vec3 p=position;
  p.y+=sin(p.x*.004+uTime*.18)*1.6+cos(p.z*.004+uTime*.13)*1.3;
  vPos=p; vN=normalize(normalMatrix*normal);
  gl_Position=projectionMatrix*modelViewMatrix*vec4(p,1.);
}
`;
const FRAG = `
varying vec3 vPos;
varying vec3 vN;
void main(){
  float n=fract(sin(vPos.x*.017+vPos.z*.023)*437.5)*.5
         +fract(sin(vPos.z*.031+vPos.x*.019)*231.7)*.5;
  vec3 col=vec3(0.65, 0.25, 0.12);
  col=mix(col, vec3(0.830,0.380,0.110), n*0.6);
  float diff=max(.55,dot(normalize(vN),normalize(vec3(1.,1.2,.6))));
  col*=diff;
  gl_FragColor=vec4(col,1.);
}
`;

const DOME_R = 290;

export function duneHeight(x, z) {
  const r = Math.sqrt(x * x + z * z);
  
  if (r < DOME_R * 0.8) {
    return -15;
  }
  
  let h = 0;
  h += Math.sin(x * 0.003  + z * 0.0015) * 38;
  h += Math.cos(x * 0.006  - z * 0.004  + 1.2) * 24;
  h += Math.sin(x * 0.013  + z * 0.009  + 3.7) * 13;
  h += Math.cos(x * 0.025  - z * 0.018) * 7;
  h += Math.sin(x * 0.058  + z * 0.05  + 2.1) * 3;
  
  const flat = 1 - Math.max(0, Math.min(1, (r - 250) / 50));
  h  *= (1 - flat * 0.96);
  return h - 20;
}

export class TerrainMesh {
  constructor(scene) { this.scene = scene; this._mat = null; }

  init() {
    const W = 64, geo = new THREE.PlaneGeometry(1800, 1800, W, W);
    geo.rotateX(-Math.PI / 2);
    const pos = geo.attributes.position.array;
    for (let i = 0; i < pos.length; i += 3)
      pos[i + 1] = duneHeight(pos[i], pos[i + 2]);
    geo.attributes.position.needsUpdate = true;
    geo.computeVertexNormals();

    this._mat = new THREE.ShaderMaterial({
      vertexShader: VERT, fragmentShader: FRAG,
      uniforms: { uTime: { value: 0 } }
    });
    const mesh = new THREE.Mesh(geo, this._mat);
    mesh.userData.noBloom = true;
    this.scene.add(mesh);
  }

  update(time) {
    if (this._mat) this._mat.uniforms.uTime.value = time;
  }
}
